import { Button, Text, Card, Stack } from "@towersystems/roam-common-native";
import { View } from "react-native-ui-lib";

import { useAuthenticationProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";
import { useTranslation } from "../../utilities/i18n";
import {
  useActiveLocation,
  useActiveTerminal,
} from "../../utilities/app-state/hooks";
import { useGlobalSettingsProvider } from "../../utilities/global-settings/hooks";

export interface CurrentStaffCardProps {
  navigation: any;
}

export const CurrentUserCard = ({ navigation }: CurrentStaffCardProps) => {
  const { t } = useTranslation("common");
  const authentication = useAuthenticationProvider();
  const { location } = useActiveLocation();
  const { terminal } = useActiveTerminal();
  const globalSettings = useGlobalSettingsProvider();

  const locationString = `${location?.name ?? "Unknown Location"} / ${
    terminal?.name ?? "Unknown Terminal"
  }`;

  const currentVendorTitle = globalSettings?.businessName ?? "Unknown Vendor";

  return (
    <View>
      <Stack spacing={2} vertical>
        <Text
          style={{ textAlign: "center" }}
          fontWeight="bold"
          variant="heading2"
        >
          {currentVendorTitle}
        </Text>
        <Text style={{ textAlign: "center" }} color="subdued">
          {locationString}
        </Text>
      </Stack>

      <View
        row
        style={{
          alignContent: "center",
          justifyContent: "center",
          marginTop: 15,
        }}
      >
        <View style={{ alignItems: "center" }}>
          <View row>
            <Button
              isAction
              style={{ marginRight: 10 }}
              label={t("switch_user")}
              size="compact"
              onPress={() => {
                navigation.closeDrawer();
                navigation.navigate("SwitchUserRootScreen");
              }}
            ></Button>
          </View>
        </View>
      </View>
    </View>
  );
};
